import NoAccessToSite from '@/views/NoAccessToSite.vue'

export default {
  component: NoAccessToSite,
  meta: {
    returnTo: '',
    showMenu: false,
  },
  name: 'noAccessToSite',
  path: '/no-access-to-site',
}
